import { autoMount } from '../../../utils/autoMount';
import { Recruitment } from '../../../components/pages/recruitment';

autoMount({ "recruitment-component": Recruitment });
